<template lang='pug'>
  .shares_edit
    el-select(
      v-model='share_id'
      placeholder='Select your share'
      @change='change_selected_share($event)')
      el-option(
        v-for='share in enabled_shares'
        :key='share.id'
        :label='share.name'
        :value='share.id')
        .share_thumb
          img(:src='share.image_url')
        i(:class="['pbxx-icon', `pbxx-icon-${get_share_icon(share.type)}`]")
        span
          | {{ share.name }}
    .form_group
      .form_item
        label
          | Image Preview
        .image_preview
          img(:src='selected_share.image_url')
      .form_item
        label
          | Copy Preview
        .froala-editor
</template>

<script>
  import _ from 'lodash'
  import Cookies from 'js-cookie'
  import { db, config_obj } from '../utils/firebase'
  import cloudinary_initializer from '../mixins/cloudinary_initializer'
  import { generate_menu } from '../utils/rich_text_menu_generator'

  export default {
    name: 'shares_edit',
    mixins: [
      cloudinary_initializer
    ],
    inject: {
      $validator: '$validator'
    },
    props: {
      landing_page_widget: {
        type: Object,
        required: true
      },
      selected_share_id: {
        type: String,
        required: true
      },
      brand: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        share_id: this.selected_share_id,
        shares: this.landing_page_widget.draft_content.shares
      }
    },
    computed: {
      enabled_shares() {
        return _.filter(this.shares, share => share.responsive_share_image_url !== '/share_images/medium/missing.png')
      },
      selected_share() {
        return _.find(this.shares, share => share.id === this.selected_share_id)
      },
      custom_fonts() {
        const font_object = {}
        if (this.brand.fonts) {
          this.brand.fonts.forEach(font => {
            const family = font.family
            font_object[family] = family
          })
        }
        if (this.brand.custom_fonts) {
          this.brand.custom_fonts.forEach(font => {
            const family = font.family
            font_object[family] = family
          })
        }
        return font_object
      },
    },
    methods: {
      change_selected_share(share_id) {
        this.$emit('change_selected_share', share_id)
        this.$nextTick(() => $('.froala-editor').froalaEditor('html.set', this.selected_share.copy))
      },
      get_share_icon(share_type) {
        switch(share_type) {
          case 'email':
            return 'local-post-office'
          case 'embed':
            return 'code'
          default:
            return share_type
        }
      },
      initialized(event, editor) {
        this.editor = editor
        $('.froala-editor').froalaEditor('html.set', this.selected_share.copy)
      },
      change_copy(val) {
        _.find(this.shares, share => {
          if (share.id !== this.selected_share_id) {
            return
          }
          share.copy = val.length ? val : '<p></p>'
        })
        this.$emit('input', this.landing_page_widget)
      }
    },
    mounted() {
      $.FroalaEditor.DefineIcon('liquid_variables', { NAME: 'cog', FA5NAME: 'cog' });
      $.FroalaEditor.RegisterCommand('liquid_variables', {
        title: 'Insert Variables',
        type: 'dropdown',
        focus: false,
        undo: false,
        html: generate_menu(),
        callback: (cmd, val) => {
          $('.froala-editor').froalaEditor('html.insert', `{{ ${val} }}`)
        }
      });

      $('.froala-editor')
        .on('froalaEditor.initialized', (e, editor) => {
          this.initialized(event, editor)
          document.getElementsByClassName('fr-element')[0].style.background = this.background
        })
        .on('froalaEditor.contentChanged', (event, editor) => {
          this.change_copy($('.froala-editor').froalaEditor('html.get'))
        })

      $('.froala-editor').froalaEditor({
        key: 'YD3A3A2C2c1A6B5B4E2A3B2F2G3C4A3D-17GLGTI1DMJc1BWLg1PO==',
        fontFamily: {
          "Lato,sans-serif": 'Lato',
          "Lucida Sans Unicode,sans-serif": 'Lucida Sans',
          "Open Sans,sans-serif": 'Open Sans',
          "Trebuchet MS,sans-serif": 'Trebuchet',
          "Source Sans Pro,sans-serif": 'Source Sans Pro',
          "Roboto,sans-serif": 'Roboto',
          ...this.custom_fonts
        },
        toolbarSticky: false,
        toolbarVisibleWithoutSelection: false,
        fontFamilySelection: true,
        heightMin: 250,
        codeViewKeepActiveButtons: ['html'],
        toolbarButtons: [
          'bold',
          'italic',
          'underline',
          'fontFamily',
          'fontSize',
          'color',
          'paragraphFormat',
          'formatUL',
          'align',
          '|',
          'subscript',
          'superscript',
          '|',
          'undo',
          'redo',
          'insertLink',
          '|',
          'fullscreen',
          'html',
          '|',
          'liquid_variables'
        ]
      })
    }
  }
</script>

<style lang='scss'>
  // Override for elementUI
  .digital-asset-uploader {
    .el-upload.el-upload--text {
      width: 100%;
      .el-upload-dragger {
        border: none;
      }
    }
  }
</style>

<style lang='scss' scoped>
  @import "@promoboxx/pbxx2component/src/styles/variables_and_mixins";

  .pbxx-icon {
    display: inline-block;
    width: 15px;
    margin-left: 15px;
  }

  .el-select-dropdown__item {
    height: 100px;
    padding: 15px;
    border-bottom: 1px solid get-color(gray-lightest);
  }

  .share_thumb {
    display: inline-block;
    width: 75px;
    height: 75px;
    float: left;
    overflow: hidden;
    position: relative;
    img {
      height: 85%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .form_group {
    margin-top: 15px;
  }

  .image_preview {
    img {
      width: 100%;
    }
  }

</style>
